import Vue from "vue";
import { Icon } from "@v2/shared/ui/components";
import simplebar from "simplebar-vue";
import "simplebar-vue/dist/simplebar.min.css";
import NotAuthLayout from "./layouts/NotAuthLayout.vue";
import DefaultLayout from "./layouts/DefaultLayout.vue";
import EmptyLayout from "./layouts/EmptyLayout.vue";
import HelpFormLayout from "./layouts/HelpFormLayout.vue";
import AppModal from "./layouts/AppModal.vue";

export const initGlobalComponents = () => {
  Vue.component("icon", Icon);
  Vue.component("simplebar", simplebar);
  Vue.component("default-layout", DefaultLayout);
  Vue.component("not-auth-layout", NotAuthLayout);
  Vue.component("empty-layout", EmptyLayout);
  Vue.component("help-form-layout", HelpFormLayout);
  Vue.component("app-modal", AppModal);
};
